/**
 * AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
 *
 * Maps app route patterns to their documentation page on docs.scrivio.nl.
 * Generated from the `route:` / `actions:` frontmatter of the view doc pages
 * under `docs/` — the same source the docs coverage check (#2654) joins against.
 *
 * Regenerate with: npm run generate:doc-routes
 */

export type DocAudience = 'behandelaar' | 'client'

export interface DocRouteEntry {
  /** Doc page path relative to the docs site root, e.g. "behandelaar/views/analyse". */
  path: string
  /** Audience the page documents (behandelaar = app.scrivio.nl, client = mijn.scrivio.nl). */
  audience: DocAudience
  /** Stable anchor slugs for documented actions on the page (one per action). */
  anchors: string[]
}

/**
 * Keyed by the route pattern (matching `path` in the router), e.g.
 * "/clients/:clientId". The value is the list of doc pages for that route — one
 * per audience, since a route can exist in both the behandelaar app and the
 * client portal (e.g. "/appointments/:id"). `useHelp` selects the entry whose
 * audience matches the running app.
 */
export const DOC_ROUTE_MAP: Record<string, DocRouteEntry[]> = {
  "/agenda": [
    {
      "path": "behandelaar/views/agenda",
      "audience": "behandelaar",
      "anchors": [
        "afspraak-aanmaken",
        "weergavemodus-wisselen",
        "weergave-wisselen",
        "op-status-filteren",
        "op-periode-filteren",
        "locatie-ruimtes-collegas-kiezen",
        "dag-week-weergave",
        "verslepen-om-te-verplaatsen",
        "afspraak-bewerken",
        "afspraak-annuleren",
        "niet-verschenen-markeren",
        "als-voltooid-markeren",
        "terugzetten-naar-gepland",
        "afspraak-verwijderen"
      ]
    }
  ],
  "/analytics": [
    {
      "path": "behandelaar/views/analyse",
      "audience": "behandelaar",
      "anchors": [
        "periode-instellen",
        "tijdseenheid-wisselen",
        "metriek-wisselen"
      ]
    }
  ],
  "/analytics/declarabiliteit": [
    {
      "path": "behandelaar/views/declarabiliteit",
      "audience": "behandelaar",
      "anchors": [
        "periode-kiezen",
        "naar-het-declaratie-inzicht"
      ]
    }
  ],
  "/appointments": [
    {
      "path": "portal/views/afspraken",
      "audience": "client",
      "anchors": [
        "aankomende-afspraken-bekijken",
        "afgelopen-afspraken-bekijken",
        "aanwezigheid-bevestigen",
        "bevestiging-intrekken",
        "afspraakdetails-bekijken",
        "online-vergaderlink-openen",
        "meer-afspraken-laden"
      ]
    }
  ],
  "/appointments/:id": [
    {
      "path": "behandelaar/views/afspraak-detail",
      "audience": "behandelaar",
      "anchors": [
        "afspraak-bewerken",
        "afspraak-voltooien",
        "afspraak-annuleren",
        "no-show-markeren",
        "herstellen-naar-gepland",
        "afspraak-verwijderen",
        "naar-dossier-navigeren",
        "transcripties-bekijken",
        "formulieren-bekijken",
        "signaleringen-bekijken"
      ]
    },
    {
      "path": "portal/views/afspraken",
      "audience": "client",
      "anchors": [
        "aankomende-afspraken-bekijken",
        "afgelopen-afspraken-bekijken",
        "aanwezigheid-bevestigen",
        "bevestiging-intrekken",
        "afspraakdetails-bekijken",
        "online-vergaderlink-openen",
        "meer-afspraken-laden"
      ]
    }
  ],
  "/claims": [
    {
      "path": "behandelaar/views/declaraties",
      "audience": "behandelaar",
      "anchors": []
    }
  ],
  "/claims/batches": [
    {
      "path": "behandelaar/views/declareren",
      "audience": "behandelaar",
      "anchors": [
        "tabbladen-wisselen",
        "afspraken-filteren-en-selecteren",
        "batch-maken",
        "facturen-genereren",
        "batches-filteren-en-bekijken",
        "xml-downloaden",
        "retour-importeren",
        "batch-afronden",
        "batch-definitief-verwijderen",
        "batch-verwijderen",
        "particuliere-afspraken-selecteren",
        "facturen-maken"
      ]
    }
  ],
  "/claims/insurer": [
    {
      "path": "behandelaar/views/declareren",
      "audience": "behandelaar",
      "anchors": [
        "tabbladen-wisselen",
        "afspraken-filteren-en-selecteren",
        "batch-maken",
        "facturen-genereren",
        "batches-filteren-en-bekijken",
        "xml-downloaden",
        "retour-importeren",
        "batch-afronden",
        "batch-definitief-verwijderen",
        "batch-verwijderen",
        "particuliere-afspraken-selecteren",
        "facturen-maken"
      ]
    }
  ],
  "/claims/invoices": [
    {
      "path": "behandelaar/views/declareren",
      "audience": "behandelaar",
      "anchors": [
        "tabbladen-wisselen",
        "afspraken-filteren-en-selecteren",
        "batch-maken",
        "facturen-genereren",
        "batches-filteren-en-bekijken",
        "xml-downloaden",
        "retour-importeren",
        "batch-afronden",
        "batch-definitief-verwijderen",
        "batch-verwijderen",
        "particuliere-afspraken-selecteren",
        "facturen-maken"
      ]
    }
  ],
  "/claims/private": [
    {
      "path": "behandelaar/views/declareren",
      "audience": "behandelaar",
      "anchors": [
        "tabbladen-wisselen",
        "afspraken-filteren-en-selecteren",
        "batch-maken",
        "facturen-genereren",
        "batches-filteren-en-bekijken",
        "xml-downloaden",
        "retour-importeren",
        "batch-afronden",
        "batch-definitief-verwijderen",
        "batch-verwijderen",
        "particuliere-afspraken-selecteren",
        "facturen-maken"
      ]
    }
  ],
  "/client-groups": [
    {
      "path": "behandelaar/views/client-groepen",
      "audience": "behandelaar",
      "anchors": [
        "groep-aanmaken",
        "zoeken",
        "sorteren",
        "pagineren",
        "naam-en-omschrijving-bewerken",
        "groep-verwijderen",
        "lid-toevoegen",
        "lidmaatschap-bewerken",
        "lid-verwijderen"
      ]
    }
  ],
  "/client-groups/:groupId": [
    {
      "path": "behandelaar/views/client-groepen",
      "audience": "behandelaar",
      "anchors": [
        "groep-aanmaken",
        "zoeken",
        "sorteren",
        "pagineren",
        "naam-en-omschrijving-bewerken",
        "groep-verwijderen",
        "lid-toevoegen",
        "lidmaatschap-bewerken",
        "lid-verwijderen"
      ]
    }
  ],
  "/clients": [
    {
      "path": "behandelaar/views/clienten",
      "audience": "behandelaar",
      "anchors": [
        "client-aanmaken",
        "zoeken",
        "op-archief-filteren",
        "op-locatie-filteren",
        "sorteren",
        "bladeren",
        "detail-openen"
      ]
    }
  ],
  "/clients/:clientId": [
    {
      "path": "behandelaar/views/client-detail",
      "audience": "behandelaar",
      "anchors": [
        "clientgegevens-bewerken",
        "profielfoto-wijzigen",
        "client-archiveren",
        "client-dearchiveren",
        "opmerking-toevoegen",
        "opmerking-bewerken",
        "opmerking-verwijderen",
        "formulier-toewijzen",
        "behandelaars-beheren",
        "signalen-bekijken",
        "statusgeschiedenis-bekijken",
        "zorgvraag-bewerken",
        "financiering-bekijken"
      ]
    }
  ],
  "/clients/:clientId/billing": [
    {
      "path": "behandelaar/views/client-financiering",
      "audience": "behandelaar",
      "anchors": [
        "financieringsbron-kiezen",
        "polis-toevoegen",
        "polis-bewerken",
        "polis-verwijderen",
        "polis-activeren",
        "iban-invoeren",
        "polissen-verifieren",
        "opslaan"
      ]
    }
  ],
  "/clients/:clientId/care-trajectories": [
    {
      "path": "behandelaar/views/zorgtrajecten",
      "audience": "behandelaar",
      "anchors": [
        "zorgtraject-aanmaken",
        "op-status-filteren",
        "zorgtraject-afsluiten",
        "zorgtraject-heropenen",
        "naam-wijzigen",
        "startdatum-wijzigen",
        "setting-wijzigen",
        "hoofdbehandelaar-wijzigen",
        "zorgvraagtypering-herijken",
        "diagnose-wijzigen",
        "profiel-wijzigen",
        "verwijzing-wijzigen",
        "verwijsbrief-bekijken",
        "zorgvraagtypering-historie-bekijken"
      ]
    }
  ],
  "/clients/:clientId/care-trajectories/:careTrajectoryId": [
    {
      "path": "behandelaar/views/zorgtrajecten",
      "audience": "behandelaar",
      "anchors": [
        "zorgtraject-aanmaken",
        "op-status-filteren",
        "zorgtraject-afsluiten",
        "zorgtraject-heropenen",
        "naam-wijzigen",
        "startdatum-wijzigen",
        "setting-wijzigen",
        "hoofdbehandelaar-wijzigen",
        "zorgvraagtypering-herijken",
        "diagnose-wijzigen",
        "profiel-wijzigen",
        "verwijzing-wijzigen",
        "verwijsbrief-bekijken",
        "zorgvraagtypering-historie-bekijken"
      ]
    }
  ],
  "/clients/:clientId/dossier": [
    {
      "path": "behandelaar/views/dossier",
      "audience": "behandelaar",
      "anchors": [
        "ai-recap",
        "recente-afspraken",
        "actieve-signalen",
        "openstaande-formulieren",
        "afspraken-filteren",
        "afspraak-bewerken",
        "afspraak-annuleren",
        "afspraak-niet-verschenen",
        "afspraak-voltooien",
        "afspraak-verwijderen",
        "identiteitsbewijs-uploaden",
        "brief-genereren",
        "verwijsbrief-uploaden",
        "verwijsbrief-bekijken",
        "verwijsbrief-downloaden",
        "verwijsbrief-verwijderen",
        "document-zichtbaarheid",
        "algemeen-document-uploaden",
        "formulierantwoorden-bekijken",
        "huisarts-toevoegen",
        "huisarts-bewerken",
        "huisarts-verwijderen",
        "contactpersoon-toevoegen",
        "contactpersoon-bewerken",
        "contactpersoon-verwijderen"
      ]
    }
  ],
  "/clients/:clientId/dossier/answers": [
    {
      "path": "behandelaar/views/dossier",
      "audience": "behandelaar",
      "anchors": [
        "ai-recap",
        "recente-afspraken",
        "actieve-signalen",
        "openstaande-formulieren",
        "afspraken-filteren",
        "afspraak-bewerken",
        "afspraak-annuleren",
        "afspraak-niet-verschenen",
        "afspraak-voltooien",
        "afspraak-verwijderen",
        "identiteitsbewijs-uploaden",
        "brief-genereren",
        "verwijsbrief-uploaden",
        "verwijsbrief-bekijken",
        "verwijsbrief-downloaden",
        "verwijsbrief-verwijderen",
        "document-zichtbaarheid",
        "algemeen-document-uploaden",
        "formulierantwoorden-bekijken",
        "huisarts-toevoegen",
        "huisarts-bewerken",
        "huisarts-verwijderen",
        "contactpersoon-toevoegen",
        "contactpersoon-bewerken",
        "contactpersoon-verwijderen"
      ]
    }
  ],
  "/clients/:clientId/dossier/appointments": [
    {
      "path": "behandelaar/views/dossier",
      "audience": "behandelaar",
      "anchors": [
        "ai-recap",
        "recente-afspraken",
        "actieve-signalen",
        "openstaande-formulieren",
        "afspraken-filteren",
        "afspraak-bewerken",
        "afspraak-annuleren",
        "afspraak-niet-verschenen",
        "afspraak-voltooien",
        "afspraak-verwijderen",
        "identiteitsbewijs-uploaden",
        "brief-genereren",
        "verwijsbrief-uploaden",
        "verwijsbrief-bekijken",
        "verwijsbrief-downloaden",
        "verwijsbrief-verwijderen",
        "document-zichtbaarheid",
        "algemeen-document-uploaden",
        "formulierantwoorden-bekijken",
        "huisarts-toevoegen",
        "huisarts-bewerken",
        "huisarts-verwijderen",
        "contactpersoon-toevoegen",
        "contactpersoon-bewerken",
        "contactpersoon-verwijderen"
      ]
    }
  ],
  "/clients/:clientId/dossier/appointments/:appointmentId": [
    {
      "path": "behandelaar/views/dossier",
      "audience": "behandelaar",
      "anchors": [
        "ai-recap",
        "recente-afspraken",
        "actieve-signalen",
        "openstaande-formulieren",
        "afspraken-filteren",
        "afspraak-bewerken",
        "afspraak-annuleren",
        "afspraak-niet-verschenen",
        "afspraak-voltooien",
        "afspraak-verwijderen",
        "identiteitsbewijs-uploaden",
        "brief-genereren",
        "verwijsbrief-uploaden",
        "verwijsbrief-bekijken",
        "verwijsbrief-downloaden",
        "verwijsbrief-verwijderen",
        "document-zichtbaarheid",
        "algemeen-document-uploaden",
        "formulierantwoorden-bekijken",
        "huisarts-toevoegen",
        "huisarts-bewerken",
        "huisarts-verwijderen",
        "contactpersoon-toevoegen",
        "contactpersoon-bewerken",
        "contactpersoon-verwijderen"
      ]
    }
  ],
  "/clients/:clientId/dossier/documents": [
    {
      "path": "behandelaar/views/dossier",
      "audience": "behandelaar",
      "anchors": [
        "ai-recap",
        "recente-afspraken",
        "actieve-signalen",
        "openstaande-formulieren",
        "afspraken-filteren",
        "afspraak-bewerken",
        "afspraak-annuleren",
        "afspraak-niet-verschenen",
        "afspraak-voltooien",
        "afspraak-verwijderen",
        "identiteitsbewijs-uploaden",
        "brief-genereren",
        "verwijsbrief-uploaden",
        "verwijsbrief-bekijken",
        "verwijsbrief-downloaden",
        "verwijsbrief-verwijderen",
        "document-zichtbaarheid",
        "algemeen-document-uploaden",
        "formulierantwoorden-bekijken",
        "huisarts-toevoegen",
        "huisarts-bewerken",
        "huisarts-verwijderen",
        "contactpersoon-toevoegen",
        "contactpersoon-bewerken",
        "contactpersoon-verwijderen"
      ]
    }
  ],
  "/clients/:clientId/dossier/overview": [
    {
      "path": "behandelaar/views/dossier",
      "audience": "behandelaar",
      "anchors": [
        "ai-recap",
        "recente-afspraken",
        "actieve-signalen",
        "openstaande-formulieren",
        "afspraken-filteren",
        "afspraak-bewerken",
        "afspraak-annuleren",
        "afspraak-niet-verschenen",
        "afspraak-voltooien",
        "afspraak-verwijderen",
        "identiteitsbewijs-uploaden",
        "brief-genereren",
        "verwijsbrief-uploaden",
        "verwijsbrief-bekijken",
        "verwijsbrief-downloaden",
        "verwijsbrief-verwijderen",
        "document-zichtbaarheid",
        "algemeen-document-uploaden",
        "formulierantwoorden-bekijken",
        "huisarts-toevoegen",
        "huisarts-bewerken",
        "huisarts-verwijderen",
        "contactpersoon-toevoegen",
        "contactpersoon-bewerken",
        "contactpersoon-verwijderen"
      ]
    }
  ],
  "/clients/:clientId/dossier/zorgkring": [
    {
      "path": "behandelaar/views/dossier",
      "audience": "behandelaar",
      "anchors": [
        "ai-recap",
        "recente-afspraken",
        "actieve-signalen",
        "openstaande-formulieren",
        "afspraken-filteren",
        "afspraak-bewerken",
        "afspraak-annuleren",
        "afspraak-niet-verschenen",
        "afspraak-voltooien",
        "afspraak-verwijderen",
        "identiteitsbewijs-uploaden",
        "brief-genereren",
        "verwijsbrief-uploaden",
        "verwijsbrief-bekijken",
        "verwijsbrief-downloaden",
        "verwijsbrief-verwijderen",
        "document-zichtbaarheid",
        "algemeen-document-uploaden",
        "formulierantwoorden-bekijken",
        "huisarts-toevoegen",
        "huisarts-bewerken",
        "huisarts-verwijderen",
        "contactpersoon-toevoegen",
        "contactpersoon-bewerken",
        "contactpersoon-verwijderen"
      ]
    }
  ],
  "/contracts": [
    {
      "path": "behandelaar/views/contracten",
      "audience": "behandelaar",
      "anchors": [
        "contract-aanmaken",
        "declaratiemethode-wijzigen",
        "filteren-op-status",
        "verlopen-contracten-tonen",
        "filteren-op-setting",
        "verzekeraar-locatie-datums-kiezen",
        "setting-toevoegen",
        "setting-bewerken",
        "setting-verwijderen",
        "contract-indienen",
        "contract-bewerken",
        "contract-verlopen",
        "contract-verwijderen"
      ]
    }
  ],
  "/contracts/:contractId": [
    {
      "path": "behandelaar/views/contracten",
      "audience": "behandelaar",
      "anchors": [
        "contract-aanmaken",
        "declaratiemethode-wijzigen",
        "filteren-op-status",
        "verlopen-contracten-tonen",
        "filteren-op-setting",
        "verzekeraar-locatie-datums-kiezen",
        "setting-toevoegen",
        "setting-bewerken",
        "setting-verwijderen",
        "contract-indienen",
        "contract-bewerken",
        "contract-verlopen",
        "contract-verwijderen"
      ]
    }
  ],
  "/contracts/:contractId/edit": [
    {
      "path": "behandelaar/views/contracten",
      "audience": "behandelaar",
      "anchors": [
        "contract-aanmaken",
        "declaratiemethode-wijzigen",
        "filteren-op-status",
        "verlopen-contracten-tonen",
        "filteren-op-setting",
        "verzekeraar-locatie-datums-kiezen",
        "setting-toevoegen",
        "setting-bewerken",
        "setting-verwijderen",
        "contract-indienen",
        "contract-bewerken",
        "contract-verlopen",
        "contract-verwijderen"
      ]
    }
  ],
  "/contracts/gemeente/:contractId": [
    {
      "path": "behandelaar/views/contracten",
      "audience": "behandelaar",
      "anchors": [
        "contract-aanmaken",
        "declaratiemethode-wijzigen",
        "filteren-op-status",
        "verlopen-contracten-tonen",
        "filteren-op-setting",
        "verzekeraar-locatie-datums-kiezen",
        "setting-toevoegen",
        "setting-bewerken",
        "setting-verwijderen",
        "contract-indienen",
        "contract-bewerken",
        "contract-verlopen",
        "contract-verwijderen"
      ]
    }
  ],
  "/contracts/new": [
    {
      "path": "behandelaar/views/contracten",
      "audience": "behandelaar",
      "anchors": [
        "contract-aanmaken",
        "declaratiemethode-wijzigen",
        "filteren-op-status",
        "verlopen-contracten-tonen",
        "filteren-op-setting",
        "verzekeraar-locatie-datums-kiezen",
        "setting-toevoegen",
        "setting-bewerken",
        "setting-verwijderen",
        "contract-indienen",
        "contract-bewerken",
        "contract-verlopen",
        "contract-verwijderen"
      ]
    }
  ],
  "/dashboard": [
    {
      "path": "behandelaar/views/dashboard",
      "audience": "behandelaar",
      "anchors": [
        "afspraken-bekijken",
        "transcriptie-starten",
        "afspraak-openen",
        "clientsignalen-bekijken",
        "persoonlijke-signalen-bekijken",
        "declaratiesignalen-bekijken",
        "organisatie-aanmaken"
      ]
    },
    {
      "path": "portal/views/overzicht",
      "audience": "client",
      "anchors": [
        "inloggen",
        "openstaande-formulieren",
        "gedeelde-documenten",
        "naar-formulieren",
        "naar-documenten"
      ]
    }
  ],
  "/documents": [
    {
      "path": "portal/views/documenten",
      "audience": "client",
      "anchors": [
        "documenten-bekijken",
        "documenten-laden",
        "document-downloaden",
        "document-openen",
        "akkoord-geven"
      ]
    }
  ],
  "/documents/:id": [
    {
      "path": "portal/views/documenten",
      "audience": "client",
      "anchors": [
        "documenten-bekijken",
        "documenten-laden",
        "document-downloaden",
        "document-openen",
        "akkoord-geven"
      ]
    }
  ],
  "/form-submissions": [
    {
      "path": "behandelaar/views/formulier-inzendingen",
      "audience": "behandelaar",
      "anchors": [
        "filteren",
        "filters-toepassen",
        "formulier-aanmaken",
        "antwoorden-bekijken",
        "formulier-verwijderen",
        "client-koppelen",
        "afspraak-koppelen",
        "transcripties-bekijken"
      ]
    }
  ],
  "/form-submissions/:id": [
    {
      "path": "behandelaar/views/formulier-inzendingen",
      "audience": "behandelaar",
      "anchors": [
        "filteren",
        "filters-toepassen",
        "formulier-aanmaken",
        "antwoorden-bekijken",
        "formulier-verwijderen",
        "client-koppelen",
        "afspraak-koppelen",
        "transcripties-bekijken"
      ]
    }
  ],
  "/forms": [
    {
      "path": "portal/views/formulieren",
      "audience": "client",
      "anchors": [
        "toegewezen-formulieren",
        "status-onderscheiden",
        "formulier-invullen",
        "concept-opslaan",
        "formulier-indienen",
        "ingevuld-formulier-bekijken",
        "validatie"
      ]
    }
  ],
  "/forms/:id": [
    {
      "path": "portal/views/formulieren",
      "audience": "client",
      "anchors": [
        "toegewezen-formulieren",
        "status-onderscheiden",
        "formulier-invullen",
        "concept-opslaan",
        "formulier-indienen",
        "ingevuld-formulier-bekijken",
        "validatie"
      ]
    }
  ],
  "/invoices": [
    {
      "path": "behandelaar/views/facturen",
      "audience": "behandelaar",
      "anchors": [
        "facturen-zoeken",
        "op-status-filteren",
        "uitgebreid-filteren",
        "facturen-selecteren",
        "pdf-downloaden",
        "zip-downloaden",
        "als-verstuurd-markeren",
        "betaling-registreren",
        "conceptfactuur-verwijderen",
        "factuur-bekijken",
        "creditnota-maken"
      ]
    },
    {
      "path": "portal/views/facturen",
      "audience": "client",
      "anchors": [
        "facturen-bekijken",
        "facturen-laden",
        "factuur-downloaden"
      ]
    }
  ],
  "/invoices/:invoiceId": [
    {
      "path": "behandelaar/views/facturen",
      "audience": "behandelaar",
      "anchors": [
        "facturen-zoeken",
        "op-status-filteren",
        "uitgebreid-filteren",
        "facturen-selecteren",
        "pdf-downloaden",
        "zip-downloaden",
        "als-verstuurd-markeren",
        "betaling-registreren",
        "conceptfactuur-verwijderen",
        "factuur-bekijken",
        "creditnota-maken"
      ]
    }
  ],
  "/mfa/challenge": [
    {
      "path": "behandelaar/views/mfa",
      "audience": "behandelaar",
      "anchors": [
        "mfa-inschakelen",
        "qr-code-scannen",
        "inlogverificatie-voltooien",
        "terug-naar-profiel"
      ]
    }
  ],
  "/mfa/setup": [
    {
      "path": "behandelaar/views/mfa",
      "audience": "behandelaar",
      "anchors": [
        "mfa-inschakelen",
        "qr-code-scannen",
        "inlogverificatie-voltooien",
        "terug-naar-profiel"
      ]
    }
  ],
  "/organization": [
    {
      "path": "behandelaar/views/organisatie",
      "audience": "behandelaar",
      "anchors": []
    }
  ],
  "/organization/agenda-import": [
    {
      "path": "behandelaar/views/agenda-import",
      "audience": "behandelaar",
      "anchors": [
        "werkboek-valideren",
        "bevindingen-lezen",
        "rapport-downloaden",
        "import-uitvoeren"
      ]
    }
  ],
  "/organization/appointment-types": [
    {
      "path": "behandelaar/views/afspraaktypen",
      "audience": "behandelaar",
      "anchors": [
        "afspraaktype-aanmaken",
        "sorteren",
        "afmeldtermijn-instellen",
        "naam-omschrijving-bewerken",
        "facturatiecategorie-instellen",
        "consulttype-instellen",
        "vaste-prestatiecode-instellen",
        "particuliere-prijs-instellen",
        "standaardduur-instellen",
        "rapportage-verplicht-instellen",
        "actief-instellen",
        "beroepscodes-selecteren",
        "formulieren-koppelen",
        "herinneringsregels-instellen",
        "afspraaktype-verwijderen"
      ]
    }
  ],
  "/organization/appointment-types/:appointmentTypeId": [
    {
      "path": "behandelaar/views/afspraaktypen",
      "audience": "behandelaar",
      "anchors": [
        "afspraaktype-aanmaken",
        "sorteren",
        "afmeldtermijn-instellen",
        "naam-omschrijving-bewerken",
        "facturatiecategorie-instellen",
        "consulttype-instellen",
        "vaste-prestatiecode-instellen",
        "particuliere-prijs-instellen",
        "standaardduur-instellen",
        "rapportage-verplicht-instellen",
        "actief-instellen",
        "beroepscodes-selecteren",
        "formulieren-koppelen",
        "herinneringsregels-instellen",
        "afspraaktype-verwijderen"
      ]
    }
  ],
  "/organization/audit-log": [
    {
      "path": "behandelaar/views/audit-log",
      "audience": "behandelaar",
      "anchors": [
        "op-datum-filteren",
        "op-gebruiker-filteren",
        "op-actietype-filteren",
        "op-resourcetype-filteren",
        "alleen-wijzigingen-tonen",
        "filters-wissen",
        "gegroepeerde-regel-openklappen",
        "wijzigingen-bekijken",
        "toegangsinformatie-bekijken",
        "bladeren",
        "naar-resource-navigeren"
      ]
    }
  ],
  "/organization/client-states": [
    {
      "path": "behandelaar/views/clientstatussen",
      "audience": "behandelaar",
      "anchors": [
        "status-aanmaken",
        "sorteren",
        "naam-bewerken",
        "kleur-kiezen",
        "volgorde-aanpassen",
        "actief-schakelen",
        "standaard-instellen",
        "verwijderen",
        "opslaan"
      ]
    }
  ],
  "/organization/client-states/:clientStateId": [
    {
      "path": "behandelaar/views/clientstatussen",
      "audience": "behandelaar",
      "anchors": [
        "status-aanmaken",
        "sorteren",
        "naam-bewerken",
        "kleur-kiezen",
        "volgorde-aanpassen",
        "actief-schakelen",
        "standaard-instellen",
        "verwijderen",
        "opslaan"
      ]
    }
  ],
  "/organization/declareren": [
    {
      "path": "behandelaar/views/declareren-instellingen",
      "audience": "behandelaar",
      "anchors": [
        "bekostiging-instellen",
        "declaratie-instellingen-bewerken",
        "boekhouding-bewerken",
        "behandelinstellingen-bewerken"
      ]
    }
  ],
  "/organization/documents": [
    {
      "path": "behandelaar/views/documenten",
      "audience": "behandelaar",
      "anchors": [
        "documentlabels-beheren",
        "standaarddocumenten-beheren"
      ]
    }
  ],
  "/organization/epd-import": [
    {
      "path": "behandelaar/views/epd-import",
      "audience": "behandelaar",
      "anchors": [
        "archief-uploaden",
        "verwerking-afwachten",
        "upload-hervatten"
      ]
    }
  ],
  "/organization/forms/list": [
    {
      "path": "behandelaar/views/formulieren",
      "audience": "behandelaar",
      "anchors": [
        "formulier-aanmaken",
        "formulierbouwer-openen",
        "filteren-op-status",
        "sorteren",
        "formulier-verwijderen",
        "inzendingen-bekijken",
        "formulier-activeren",
        "formulier-verouderen",
        "vraag-toevoegen",
        "tekstblok-toevoegen",
        "items-herschikken",
        "item-dupliceren",
        "item-verwijderen",
        "vraag-bewerken",
        "vraag-opslaan-in-bibliotheek",
        "formuliergegevens-bewerken",
        "doel-wijzigen",
        "aantal-inzendingen-bekijken"
      ]
    }
  ],
  "/organization/forms/list/:formId": [
    {
      "path": "behandelaar/views/formulieren",
      "audience": "behandelaar",
      "anchors": [
        "formulier-aanmaken",
        "formulierbouwer-openen",
        "filteren-op-status",
        "sorteren",
        "formulier-verwijderen",
        "inzendingen-bekijken",
        "formulier-activeren",
        "formulier-verouderen",
        "vraag-toevoegen",
        "tekstblok-toevoegen",
        "items-herschikken",
        "item-dupliceren",
        "item-verwijderen",
        "vraag-bewerken",
        "vraag-opslaan-in-bibliotheek",
        "formuliergegevens-bewerken",
        "doel-wijzigen",
        "aantal-inzendingen-bekijken"
      ]
    }
  ],
  "/organization/forms/list/:formId/settings": [
    {
      "path": "behandelaar/views/formulieren",
      "audience": "behandelaar",
      "anchors": [
        "formulier-aanmaken",
        "formulierbouwer-openen",
        "filteren-op-status",
        "sorteren",
        "formulier-verwijderen",
        "inzendingen-bekijken",
        "formulier-activeren",
        "formulier-verouderen",
        "vraag-toevoegen",
        "tekstblok-toevoegen",
        "items-herschikken",
        "item-dupliceren",
        "item-verwijderen",
        "vraag-bewerken",
        "vraag-opslaan-in-bibliotheek",
        "formuliergegevens-bewerken",
        "doel-wijzigen",
        "aantal-inzendingen-bekijken"
      ]
    }
  ],
  "/organization/forms/questions": [
    {
      "path": "behandelaar/views/vragen-bibliotheek",
      "audience": "behandelaar",
      "anchors": [
        "vraag-aanmaken",
        "vraag-bewerken",
        "versiegeschiedenis-bekijken",
        "vraag-verwijderen",
        "vraag-archiveren",
        "vraag-herstellen",
        "sorteren",
        "gearchiveerde-tonen"
      ]
    }
  ],
  "/organization/imports/:runId": [
    {
      "path": "behandelaar/views/import-beoordelen",
      "audience": "behandelaar",
      "anchors": [
        "levering-bekijken",
        "regels-doorlopen",
        "samenvoeging-bekijken",
        "import-goedkeuren",
        "import-afwijzen",
        "voortgang-volgen"
      ]
    }
  ],
  "/organization/integrations": [
    {
      "path": "behandelaar/views/integraties",
      "audience": "behandelaar",
      "anchors": [
        "certificaten-tab-openen",
        "zivver-tab-openen",
        "certificaat-configureren",
        "zivver-configureren"
      ]
    }
  ],
  "/organization/letter-templates": [
    {
      "path": "behandelaar/views/brief-templates",
      "audience": "behandelaar",
      "anchors": [
        "template-aanmaken",
        "template-bewerken",
        "template-dupliceren",
        "template-archiveren",
        "filteren-op-status",
        "sorteren",
        "inhoud-bewerken",
        "samenvoegveld-invoegen",
        "opslaan-als-concept",
        "activeren",
        "preview-bekijken",
        "versturen-via-zivver"
      ]
    }
  ],
  "/organization/letter-templates/:id": [
    {
      "path": "behandelaar/views/brief-templates",
      "audience": "behandelaar",
      "anchors": [
        "template-aanmaken",
        "template-bewerken",
        "template-dupliceren",
        "template-archiveren",
        "filteren-op-status",
        "sorteren",
        "inhoud-bewerken",
        "samenvoegveld-invoegen",
        "opslaan-als-concept",
        "activeren",
        "preview-bekijken",
        "versturen-via-zivver"
      ]
    }
  ],
  "/organization/letter-templates/new": [
    {
      "path": "behandelaar/views/brief-templates",
      "audience": "behandelaar",
      "anchors": [
        "template-aanmaken",
        "template-bewerken",
        "template-dupliceren",
        "template-archiveren",
        "filteren-op-status",
        "sorteren",
        "inhoud-bewerken",
        "samenvoegveld-invoegen",
        "opslaan-als-concept",
        "activeren",
        "preview-bekijken",
        "versturen-via-zivver"
      ]
    }
  ],
  "/organization/locations": [
    {
      "path": "behandelaar/views/locaties",
      "audience": "behandelaar",
      "anchors": [
        "locatie-aanmaken",
        "sorteren",
        "locatiegegevens-bewerken",
        "locatie-activeren",
        "kamer-aanmaken",
        "kamer-bewerken",
        "kamer-verwijderen",
        "kamer-activeren",
        "opslaan"
      ]
    }
  ],
  "/organization/locations/:locationId": [
    {
      "path": "behandelaar/views/locaties",
      "audience": "behandelaar",
      "anchors": [
        "locatie-aanmaken",
        "sorteren",
        "locatiegegevens-bewerken",
        "locatie-activeren",
        "kamer-aanmaken",
        "kamer-bewerken",
        "kamer-verwijderen",
        "kamer-activeren",
        "opslaan"
      ]
    }
  ],
  "/organization/practice": [
    {
      "path": "behandelaar/views/praktijkgegevens",
      "audience": "behandelaar",
      "anchors": [
        "logo-beheren",
        "naam-bewerken",
        "contactgegevens-bewerken",
        "adresgegevens-bewerken",
        "kvk-agb-bewerken",
        "zorgaanbiedersoort-instellen",
        "iban-bewerken"
      ]
    }
  ],
  "/organization/roles": [
    {
      "path": "behandelaar/views/rollen-rechten",
      "audience": "behandelaar",
      "anchors": [
        "rol-aanmaken",
        "rol-bewerken",
        "rol-verwijderen",
        "sorteren",
        "rechten-bekijken",
        "rechten-toewijzen",
        "naam-omschrijving-bewerken",
        "opslaan"
      ]
    }
  ],
  "/organization/security": [
    {
      "path": "behandelaar/views/beveiliging",
      "audience": "behandelaar",
      "anchors": [
        "mfa-beleid-beheren"
      ]
    }
  ],
  "/organization/signals": [
    {
      "path": "behandelaar/views/signaaldefinities",
      "audience": "behandelaar",
      "anchors": [
        "signalering-aanmaken",
        "in-uitschakelen",
        "veld-instellen",
        "details-bekijken",
        "signalering-bewerken",
        "signalering-verwijderen",
        "sorteren"
      ]
    }
  ],
  "/organization/signals/authoring": [
    {
      "path": "behandelaar/views/signaaldefinities-opstellen",
      "audience": "behandelaar",
      "anchors": [
        "beschrijven-en-genereren",
        "voorbeeld-bekijken",
        "opslaan"
      ]
    }
  ],
  "/organization/subscription": [
    {
      "path": "behandelaar/views/abonnement",
      "audience": "behandelaar",
      "anchors": [
        "factuurgegevens-bewerken",
        "betaalwijze-kiezen",
        "machtiging-afgeven",
        "factuur-downloaden",
        "factuur-betalen",
        "abonnement-opzeggen"
      ]
    }
  ],
  "/organization/teams": [
    {
      "path": "behandelaar/views/teams",
      "audience": "behandelaar",
      "anchors": [
        "team-aanmaken",
        "zoeken-en-sorteren",
        "naam-en-omschrijving-bewerken",
        "actief-status-wijzigen",
        "lid-toevoegen",
        "lid-verwijderen",
        "wijzigingen-opslaan"
      ]
    }
  ],
  "/organization/teams/:teamId": [
    {
      "path": "behandelaar/views/teams",
      "audience": "behandelaar",
      "anchors": [
        "team-aanmaken",
        "zoeken-en-sorteren",
        "naam-en-omschrijving-bewerken",
        "actief-status-wijzigen",
        "lid-toevoegen",
        "lid-verwijderen",
        "wijzigingen-opslaan"
      ]
    }
  ],
  "/organization/users": [
    {
      "path": "behandelaar/views/gebruikers",
      "audience": "behandelaar",
      "anchors": [
        "gebruiker-uitnodigen",
        "gebruiker-aanmaken",
        "zoeken",
        "sorteren",
        "op-status-filteren",
        "openstaande-uitnodigingen-bekijken",
        "uitnodiging-intrekken",
        "gebruiker-activeren-deactiveren",
        "behandelaar-aanzetten",
        "behandelaargegevens-invullen",
        "rollen-toewijzen",
        "team-toewijzen",
        "opslaan"
      ]
    }
  ],
  "/organization/users/:userId": [
    {
      "path": "behandelaar/views/gebruikers",
      "audience": "behandelaar",
      "anchors": [
        "gebruiker-uitnodigen",
        "gebruiker-aanmaken",
        "zoeken",
        "sorteren",
        "op-status-filteren",
        "openstaande-uitnodigingen-bekijken",
        "uitnodiging-intrekken",
        "gebruiker-activeren-deactiveren",
        "behandelaar-aanzetten",
        "behandelaargegevens-invullen",
        "rollen-toewijzen",
        "team-toewijzen",
        "opslaan"
      ]
    }
  ],
  "/profile": [
    {
      "path": "behandelaar/views/profiel",
      "audience": "behandelaar",
      "anchors": [
        "profiel-bewerken",
        "taalvoorkeur-wijzigen",
        "mfa-instellen",
        "zivver-status-bijwerken"
      ]
    }
  ],
  "/signaleringen": [
    {
      "path": "behandelaar/views/signaleringen",
      "audience": "behandelaar",
      "anchors": [
        "signalering-openen",
        "meer-signaleringen-laden",
        "opnieuw-proberen"
      ]
    }
  ]
}
